if($('footer#footer').length){
    $('footer#footer').before($('.customreviews'));
    $('.in-index footer#footer').before($('.blogFeeds'));
    $('footer#footer .newsletterWrap .container').append($('footer#footer #formNewsletterWidget'));
    $('footer#footer').before($('footer#footer .newsletterWrap'));
    $(document).on('click', 'footer#footer h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });
    $('.footer-bottom').wrapInner('<div class="left"></div>')
    $('.footer-bottom #signature').html($('footer#footer .signature'));
    $('.footer-bottom').append($('footer#footer .paymentAndShipping'));
    $('.footer-bottom').append($('footer#footer .backToTop'));
    $('footer#footer .topContact').append($('footer#footer .contact-box li span.mail').closest('li').clone());
    $('footer#footer .topContact').append($('footer#footer .contact-box li span.tel').closest('li').clone());

    $('footer#footer .socialContact').append($('footer#footer .contact-box li span.facebook').closest('li').clone());
    $('footer#footer .socialContact').append($('footer#footer .contact-box li span.instagram').closest('li').clone());
    $('footer#footer .socialContact').append($('footer#footer .contact-box li span.youtube').closest('li').clone());   

    $('html').on('click', '.backToTop', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 1000);
    });

    var currentHour = new Date().getHours();
    $('.tel').append('<i>'+openhours+'</i>')
    if (currentHour >= startWork && currentHour < stopWork) {
        $('.tel i').addClass('inWork').removeClass('outWork');
    } else {
        $('.tel i').addClass('outWork').removeClass('inWork');
    }
    $('.top-navigation-bar .container').append($('footer#footer .topMessage'));
    $('.top-navigation-bar .container .top-navigation-menu').prepend($('footer#footer .priceWith'));
    $('.top-navigation-bar .container .top-navigation-menu').prepend($('.top-navigation-bar .languagesMenu'));
    $('.site-name-wrapper').append($('footer#footer .claim'), $('footer#footer .contact-box li span.tel').clone())
}
else{
    if(sessionStorage.loadedFooter) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
              customHeader()
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customHeader()
                    }
                });
            }
}

function customHeader(){
    $('.top-navigation-bar .container').append($('footer#footer .topMessage'));
    $('.top-navigation-bar .container .top-navigation-menu').prepend($('footer#footer .priceWith'));
    $('.top-navigation-bar .container .top-navigation-menu').prepend($('.top-navigation-bar .languagesMenu'));
    $('.site-name-wrapper').append($('footer#footer .claim'), $('footer#footer .contact-box li span.tel').clone())
    var currentHour = new Date().getHours();
    $('.tel').append('<i>'+openhours+'</i>')
    if (currentHour >= startWork && currentHour < stopWork) {
        $('.tel i').addClass('inWork').removeClass('outWork');
    } else {
        $('.tel i').addClass('outWork').removeClass('inWork');
    }
}

$('html').on('click', '.priceWith .priceLabel', function(){
    $(this).next('ul').toggleClass('open')
})